/**
 * Experiments whose assignment is operationally meaningful get the brand
 * (purple) chip; anything else renders neutral. Keyed by experiment name as
 * stored in `conversation_variants.experiment`.
 */
export const HIGHLIGHTED_EXPERIMENTS: ReadonlySet<string> = new Set(['rag_engine']);

export const BADGE_BASE_CLASS =
	'inline-flex items-center gap-3xs rounded-md px-2xs py-3xs text-[11px] font-medium leading-none tracking-tight';

export const BADGE_VARIANT_CLASS = {
	highlighted: 'bg-purple-50 text-purple-700',
	neutral: 'bg-grey-25 text-subtle',
} as const;
